import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import ym from "react-yandex-metrika";
import { Link } from 'react-router-dom'
import SourcesMarketingForm from '../Sources/SourcesMarketingForm'
import SourcesMarketingFormReferrer from '../Sources/SourcesMarketingFormReferrer'
import $ from 'jquery';
import {hit} from '../metrics';
import mapStateToProps from '../../store/mapStateToProps';
import mapDispatchToProps from '../../store/mapDispatchToProps';
import { isReferrer } from '../helpers/getReferrer';

const PromoteDesctope = (props) => {

  const [popup, setPopup] = useState(false)
  const [smr, setSmr] = useState(null)

  useEffect(() => {

    $('.promote-arrow, .promote__figures').click(function(){
      $('html, body').animate({scrollTop: window.innerHeight*2.5}, 1000)
    });

    props.setPageId('advertising');

		setTimeout(() => {
			$("body").addClass("fadepage");
		}, 100);

		$('body').addClass('page-sources hash-promote');
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    window.gsap.registerPlugin(window.ScrollTrigger, window.ScrollSmoother);

    var lastScrollTop = 0;

    var isScroll = false

    var timer;

    let smoother = window.ScrollSmoother.create({
      smooth: 2,
      effects: true,
      smoothTouch: true,
      normalizeScroll: false,
      onUpdate: e => {
        const y = e.scrollTop()
        isScroll = true

        if(timer){
          clearTimeout(timer)
        }

        if($('.hash-promote').length){
          if (y > lastScrollTop && y > window.innerHeight*2.5){
            $('body').removeClass('fixedd');
          }
          else {
            if(!$('body').hasClass("fixedd")){
              $('body').addClass('fixedd');
            }
          }
          lastScrollTop = y <= 0 ? 0 : y;
        }
      }
    });

    timer = setTimeout(() => {
      if(!isScroll){
        //const value = window.innerHeight*2;
        //smoother.scrollTo(value)
      }
    }, 4000)

    setSmr(smoother)

    window.ScrollTrigger.create({
      trigger: ".promote__top",
      pin: true,
      start: "top top",
      end: "+=" + window.innerHeight * 2.5
    });

    let title = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__top',
        start: 0,
        end: window.innerHeight * 2,
        scrub: 0.5,
      }
    });

    let b1_0 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__complex .marketing-title2',
        start: "top bottom+="+window.innerHeight/2,
        end: "center center",
        scrub: 0.5,
      }
    });

    let b1 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__complex .marketing-title2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b2 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__complex-row',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b2_1 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__complex-row',
        start: "center 46%",
        end: "bottom 46%",
        scrub: 0.5,
      }
    });

    let b2_2 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__complex-row',
        start: "center 43%",
        end: "bottom 43%",
        scrub: 0.5,
      }
    });

    let b2_3 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__complex-row',
        start: "center 40%",
        end: "bottom 40%",
        scrub: 0.5,
      }
    });

    let b3 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-complex .marketing-title2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b4 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-complex__item1',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b5 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-complex__item2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b6 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-complex__item3',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b7 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-hon .marketing-title2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b8 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-hon__list',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b9 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-work .marketing-title2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b10 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-work__in',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b11 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-prof .marketing-title2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b12 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-prof__row:nth-child(2)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b13 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-prof__row:nth-child(3)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });


    let b14 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-technology .marketing-title2',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b15 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-technology__row:nth-child(2)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b16 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-technology__row:nth-child(3)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b17 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-technology__row:nth-child(4)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b18 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-technology__row:nth-child(5)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b19 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote .marketing-technology__row:nth-child(6)',
        start: "top bottom",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    let b20 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.promote__bottom',
        start: "top center",
        end: "top top",
        scrub: 0.5,
      }
    });

    let b21 = window.gsap.timeline({
      scrollTrigger: {
        trigger: '.marketing-work',
        start: "top center",
        end: "bottom center",
        scrub: 0.5,
      }
    });

    title.to('.promote__title > div > div', {y: 0, x: 0}, 0)
    title.to('.promote__top-animate', {y: 0}, 0)
    title.to('.promote__figures > div', {y: 0, x: 0}, 0)
    title.to('.promote__top-bottom', {y: 0}, 0)
    b1_0.to('.promote-arrow', {opacity: 0}, 0)
    b1.to('.promote__complex .marketing-title2', {x: 0, opacity: 1}, 0)
    b2.to('.promote__complex-row', {x: 0, opacity: 1}, 0)
    /*b2_1.to('.promote__complex-row-p3', {opacity: 1, y: 0}, 0)
    b2_2.to('.promote__complex-row-p2', {opacity: 1, y: 0}, 0)
    b2_3.to('.promote__complex-row-p1', {opacity: 1, y: 0}, 0)*/

    b2_1.to('.promote__complex-icon1 svg', {y: 0}, 0)
    b2_2.to('.promote__complex-icon2 svg', {y: 0}, 0)
    b2_3.to('.promote__complex-icon3 svg', {y: 0}, 0)

    b3.to('.promote .marketing-complex .marketing-title2', {x: 0, opacity: 1}, 0)
    b4.to('.promote .marketing-complex__item1', {x: 0, opacity: 1}, 0)
    b5.to('.promote .marketing-complex__item2', {x: 0, opacity: 1}, 0)
    b6.to('.promote .marketing-complex__item3', {x: 0, opacity: 1}, 0)
    b7.to('.promote .marketing-hon .marketing-title2', {x: 0, opacity: 1}, 0)
    b8.to('.promote .marketing-hon__list', {x: 0, opacity: 1}, 0)
    b9.to('.promote .marketing-work .marketing-title2', {x: 0, opacity: 1}, 0)
    b10.to('.promote .marketing-work__in', {x: 0, opacity: 1}, 0)
    b11.to('.promote .marketing-prof .marketing-title2', {x: 0, opacity: 1}, 0)
    b12.to('.promote .marketing-prof__row:nth-child(2)', {x: 0, opacity: 1}, 0)
    b13.to('.promote .marketing-prof__row:nth-child(3)', {x: 0, opacity: 1}, 0)
    b14.to('.promote .marketing-technology .marketing-title2', {x: 0, opacity: 1}, 0)
    b15.to('.promote .marketing-technology__row:nth-child(2)', {x: 0, opacity: 1}, 0)
    b16.to('.promote .marketing-technology__row:nth-child(3)', {x: 0, opacity: 1}, 0)
    b17.to('.promote .marketing-technology__row:nth-child(4)', {x: 0, opacity: 1}, 0)
    b18.to('.promote .marketing-technology__row:nth-child(5)', {x: 0, opacity: 1}, 0)
    b19.to('.promote .marketing-technology__row:nth-child(6)', {x: 0, opacity: 1}, 0)
    b20.to('.promote__bottom .marketing-title2', {color: '#fff', y: "8vw"}, 0)
    b20.to('.promote__bottom-button', {y: "8vw"}, 0)
    b20.to('.promote__bottom-el1', {scaleY: 0}, 0)
    b20.to('.promote__bottom-el2, .promote__bottom-el3', {scaleX: 0}, 0)
    b21.to('.marketing-work__img-bg', {scaleX: 0}, 0)

    return () => {
      $('body').removeClass('page-sources tags-expanded hash-promote fadepage');
    }

  },[]);

  return(
    <Fragment>

      <div className="promote__top-bottom-button" onClick={() => props.openPopup(true)}>
				<span>Мы на связи</span>
				{/* <img src="/img/promote/lightning_promote.svg" /> */}
			</div>

      <div className={popup ? 'contacts-call-me-popup active' : 'contacts-call-me-popup'}>
        <div><SourcesMarketingForm close={() => setPopup(false)} /></div>

        <div className="contacts-call-me-popup__close" onClick={() => setPopup(false)}></div>
      </div>

      <div id="smooth-wrapper" className="promote-smooth-wrapper">
        <div id="smooth-content">
          <div className="promote">
            <div className="promote__top">

            <div className="promote-arrow">
                Прокручивайте страницу
                <div>
                  <svg width="49" height="79" viewBox="0 0 49 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.5 2V72" stroke="black" strokeWidth="3" strokeLinecap="round"/>
                    <path d="M12.5 61L24.5 73L36.5 61" stroke="black" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                  <svg width="49" height="79" viewBox="0 0 49 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.5 2V72" stroke="black" strokeWidth="3" strokeLinecap="round"/>
                    <path d="M12.5 61L24.5 73L36.5 61" stroke="black" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </div>
              </div>

              <div className="promote__top-in">
                {/*<div className="promote__subtitle">Продвигаем</div>*/}

                <div className="promote__top-animate">
                  <div className="promote__title">
                    <div>
                      <div>D</div>
                      <div>i</div>
                      <div>g</div>
                      <div>i</div>
                      <div>t</div>
                      <div>a</div>
                      <div>l</div>
                      <div>&nbsp;</div>
                      <div>M</div>
                      <div>a</div>
                      <div>r</div>
                      <div>k</div>
                      <div>e</div>
                      <div>t</div>
                      <div>i</div>
                      <div>n</div>
                      <div>g</div></div>
                    <div>
                      <div>в</div>
                      <div>&nbsp;</div>
                      <div>д</div>
                      <div>е</div>
                      <div>й</div>
                      <div>с</div>
                      <div>т</div>
                      <div>в</div>
                      <div>и</div>
                      <div>и</div>
                      <div>!</div>
                    </div>
                  </div>

                  <div className="promote__figures">
                    <div>
                      <div>
                        <video playsInline loop muted autoPlay>
                          <source src="/video/promote/promote_video_f1_n.mp4" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                    <div>
                      <div>
                        <video playsInline loop muted autoPlay>
                          <source src="/video/promote/promote_video_f2_n.mp4" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                    <div>
                      <div>
                        <video playsInline loop muted autoPlay>
                          <source src="/video/promote/promote_video_f3_n.mp4" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                    <div>
                      <div>
                        <video playsInline loop muted autoPlay>
                          <source src="/video/promote/promote_video_f4_n.mp4" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="promote__top-bottom">
                <div>Системно. Эффективно. Оперативно.</div>
                <div style={{opacity: 0}} className="promote__top-bottom-button"><span>Мы на связи</span><img src="/img/promote/lightning_promote.svg" /></div>
              </div>
            </div>

            <div className="promote__complex">
              <div className="marketing-title2">
              Комплексный <br />
              подход
              </div>

              <div className="promote__complex-row">
                <div>
                  <div>Социальные сети</div>
                  <div>
                    <div className="promote__complex-icon promote__complex-icon1">
                      <svg width="217" height="217" viewBox="0 0 217 217" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M137.22 156.52C142.44 149.18 140.14 136.38 126.76 134.52C110.76 132.24 99.44 133.14 98.54 132.08C96.54 129.82 100 120.08 100.98 117.28C102.88 111.98 104.82 106.48 103.6 99.12C101.6 87.12 90.88 81.12 85.46 81.12C82.8 81.12 76.58 82.22 76.14 92.52C75.54 106.4 62.9 111.34 56.9 122.52C49.82 135.64 42.42 141.56 39.4 142.3C33.6302 143.025 27.8093 143.259 22 143C21.4702 142.983 20.9426 143.075 20.4497 143.271C19.9569 143.466 19.5093 143.76 19.1345 144.134C18.7597 144.509 18.4656 144.957 18.2705 145.45C18.0754 145.943 17.9833 146.47 18 147V183C18 203.92 26 211.5 31.08 210.22C35.6407 208.902 40.3386 208.117 45.08 207.88C59.6 211.32 55.96 218.88 101.44 216.54C116.08 215.8 122.42 214.86 126.34 208.54C127.385 206.995 128.071 205.236 128.348 203.391C128.625 201.547 128.485 199.664 127.94 197.88C136.98 194.48 138.8 186.46 135.68 179.2C144.34 173.24 144.3 163 137.22 156.52ZM128.86 173.78C128.247 173.993 127.695 174.353 127.252 174.827C126.809 175.301 126.488 175.876 126.317 176.502C126.145 177.128 126.129 177.787 126.269 178.42C126.409 179.054 126.701 179.644 127.12 180.14C127.934 181.166 128.507 182.362 128.794 183.64C129.081 184.918 129.077 186.244 128.78 187.52C128 189.86 123.36 191.06 121.38 191.26C120.615 191.34 119.889 191.639 119.289 192.122C118.69 192.604 118.242 193.25 118 193.98C116.42 198.66 123.16 198.6 119.62 204.3C118.12 206.72 116.04 207.78 101.1 208.56C40.98 211.64 63.9 194.08 30.82 202.06C29.3 200.66 26.04 195.72 26.04 183V151C31.2795 151.206 36.5257 150.824 41.68 149.86C48.44 148.22 56.98 139.14 63.98 126.18C69.14 116.6 83.42 110.18 84.18 92.78C84.18 90.28 84.72 89.02 85.5 89.02C88.1187 89.7278 90.4777 91.1761 92.294 93.191C94.1103 95.206 95.3068 97.7021 95.74 100.38C96.62 105.72 95.24 109.62 93.5 114.56C91.06 121.42 87.72 131.6 92.46 137.2C93.6113 138.382 95.01 139.294 96.5557 139.872C98.1013 140.449 99.7557 140.677 101.4 140.54C104.48 140.54 119.02 141.44 125.66 142.4C130 143.02 131.66 144.7 131.8 148.62C131.765 149.608 131.493 150.573 131.005 151.433C130.518 152.293 129.83 153.023 129 153.56C128.375 153.931 127.863 154.465 127.519 155.105C127.174 155.745 127.011 156.466 127.046 157.192C127.081 157.918 127.313 158.621 127.717 159.225C128.121 159.829 128.682 160.311 129.34 160.62C135.8 163.88 136.38 171 128.86 173.78Z" fill="black"/>
                      <path d="M216.58 68.52L214.58 52.52C214.458 51.548 213.983 50.6547 213.245 50.0096C212.508 49.3644 211.56 49.0123 210.58 49.02H207.7L206.46 44.04C206.247 43.1794 205.755 42.4138 205.06 41.8636C204.365 41.3133 203.506 41.0096 202.62 41H122.62C121.729 40.9996 120.864 41.2964 120.161 41.8435C119.458 42.3905 118.958 43.1565 118.74 44.02L117.5 49H114.62C113.64 48.9923 112.692 49.3444 111.955 49.9896C111.217 50.6347 110.742 51.528 110.62 52.5L108.62 68.5C108.549 69.0657 108.599 69.6401 108.768 70.1847C108.937 70.7292 109.22 71.2314 109.599 71.6576C109.978 72.0837 110.443 72.424 110.964 72.6555C111.485 72.887 112.05 73.0045 112.62 73H116.78L120.94 123.12C121.028 124.181 121.533 125.164 122.345 125.852C123.157 126.54 124.209 126.878 125.27 126.79C126.331 126.702 127.314 126.197 128.002 125.385C128.69 124.573 129.028 123.521 128.94 122.46L124.8 73H200.24L192.9 177H149.4C148.339 177 147.322 177.421 146.572 178.172C145.821 178.922 145.4 179.939 145.4 181C145.4 182.061 145.821 183.078 146.572 183.828C147.322 184.579 148.339 185 149.4 185H196.62C197.634 185.002 198.611 184.62 199.354 183.929C200.096 183.238 200.549 182.292 200.62 181.28L208.26 73H212.62C213.185 72.9984 213.743 72.8772 214.258 72.6444C214.772 72.4116 215.232 72.0724 215.606 71.6492C215.98 71.2259 216.26 70.7283 216.428 70.1889C216.596 69.6496 216.648 69.0808 216.58 68.52ZM118.14 57H120.62C121.513 56.9993 122.381 56.6996 123.084 56.1487C123.787 55.5977 124.286 54.8272 124.5 53.96L125.74 49H199.5L200.74 53.96C200.954 54.8272 201.453 55.5977 202.156 56.1487C202.859 56.6996 203.727 56.9993 204.62 57H207.08L208.08 65H117.14L118.14 57Z" fill="black"/>
                      <path d="M52.38 113C53.4409 113 54.4583 112.579 55.2084 111.828C55.9586 111.078 56.38 110.061 56.38 109C56.38 107.939 55.9586 106.922 55.2084 106.172C54.4583 105.421 53.4409 105 52.38 105H22C18.5059 105.043 15.1374 103.698 12.633 101.261C10.1286 98.8244 8.69268 95.4939 8.63999 92V22C8.69268 18.506 10.1286 15.1755 12.633 12.7386C15.1374 10.3017 18.5059 8.95721 22 8.99997H128.54C120.019 14.0491 113.42 21.7885 109.78 31C109.393 31.9892 109.414 33.0918 109.84 34.0651C110.266 35.0384 111.061 35.8027 112.05 36.19C113.039 36.5772 114.142 36.5556 115.115 36.1298C116.088 35.7041 116.853 34.9092 117.24 33.92C120.254 26.3587 125.71 20.0227 132.74 15.92C134.258 15.0573 135.44 13.7065 136.094 12.0871C136.747 10.4677 136.834 8.67489 136.34 6.99997C135.864 5.25237 134.819 3.7134 133.37 2.62666C131.921 1.53992 130.151 0.967485 128.34 0.999967H22C19.2169 0.973586 16.4559 1.496 13.8748 2.53733C11.2937 3.57866 8.9432 5.1185 6.9576 7.06881C4.972 9.01913 3.39026 11.3417 2.30281 13.9037C1.21536 16.4656 0.643524 19.2168 0.619995 22V92C0.672804 97.6191 2.95441 102.987 6.96341 106.925C10.9724 110.863 16.3808 113.048 22 113H52.38Z" fill="black"/>
                      </svg>
                      <div>
                        <svg width="217" height="217" viewBox="0 0 217 217" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M86.62 49.0001C87.6809 49.0001 88.6983 48.5786 89.4484 47.8285C90.1986 47.0783 90.62 46.0609 90.62 45.0001C90.62 43.9392 90.1986 42.9218 89.4484 42.1716C88.6983 41.4215 87.6809 41.0001 86.62 41.0001H76.62L78.62 29.7001C78.8083 28.6551 78.5738 27.5781 77.968 26.7061C77.3623 25.8341 76.4349 25.2384 75.39 25.05C74.345 24.8617 73.2681 25.0963 72.396 25.702C71.524 26.3077 70.9283 27.2351 70.74 28.28L68.42 41.0001H52.54L54.54 29.7001C54.7283 28.6551 54.4938 27.5781 53.888 26.7061C53.2823 25.8341 52.3549 25.2384 51.31 25.05C50.265 24.8617 49.1881 25.0963 48.316 25.702C47.444 26.3077 46.8483 27.2351 46.66 28.28L44.42 41.0001H32.62C31.5591 41.0001 30.5417 41.4215 29.7916 42.1716C29.0414 42.9218 28.62 43.9392 28.62 45.0001C28.62 46.0609 29.0414 47.0783 29.7916 47.8285C30.5417 48.5786 31.5591 49.0001 32.62 49.0001H42.98L40.12 65H28.62C27.5591 65 26.5417 65.4215 25.7916 66.1716C25.0414 66.9218 24.62 67.9392 24.62 69C24.62 70.0609 25.0414 71.0783 25.7916 71.8285C26.5417 72.5786 27.5591 73 28.62 73H38.62L36.62 84.28C36.4317 85.325 36.6662 86.402 37.2719 87.274C37.8777 88.146 38.805 88.7417 39.85 88.93C40.8949 89.1184 41.9719 88.8838 42.844 88.2781C43.716 87.6724 44.3117 86.745 44.5 85.7L46.82 73H62.7L60.7 84.28C60.5117 85.325 60.7462 86.402 61.3519 87.274C61.9577 88.146 62.885 88.7417 63.93 88.93C64.9749 89.1184 66.0519 88.8838 66.924 88.2781C67.796 87.6724 68.3917 86.745 68.58 85.7L70.82 73H82.62C83.6809 73 84.6983 72.5786 85.4484 71.8285C86.1986 71.0783 86.62 70.0609 86.62 69C86.62 67.9392 86.1986 66.9218 85.4484 66.1716C84.6983 65.4215 83.6809 65 82.62 65H72.26L75.12 49.0001H86.62ZM64.12 65H48.26L51.12 49.0001H66.98L64.12 65Z" fill="#2F80ED" stroke="#2F80ED"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <div className="promote__complex-row-plus"><img src="/img/promote/complex_plus.svg" /></div>
                </div>
                <div>
                  <div>Контекстная реклама</div>
                  <div>
                    <div className="promote__complex-icon promote__complex-icon2">
                      <svg width="192" height="192" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 60.58C5.06087 60.58 6.07828 60.1586 6.82843 59.4084C7.57857 58.6583 8 57.6409 8 56.58V8H56.58C57.6409 8 58.6583 7.57857 59.4084 6.82843C60.1586 6.07828 60.58 5.06087 60.58 4C60.58 2.93913 60.1586 1.92172 59.4084 1.17157C58.6583 0.421428 57.6409 0 56.58 0H4C2.93913 0 1.92172 0.421428 1.17157 1.17157C0.421428 1.92172 0 2.93913 0 4V56.58C0 57.6409 0.421428 58.6583 1.17157 59.4084C1.92172 60.1586 2.93913 60.58 4 60.58Z" fill="black"/>
                      <path d="M56.58 184H8V135.42C8 134.359 7.57857 133.342 6.82843 132.592C6.07828 131.841 5.06087 131.42 4 131.42C2.93913 131.42 1.92172 131.841 1.17157 132.592C0.421428 133.342 0 134.359 0 135.42V188C0 189.061 0.421428 190.078 1.17157 190.828C1.92172 191.579 2.93913 192 4 192H56.58C57.6409 192 58.6583 191.579 59.4084 190.828C60.1586 190.078 60.58 189.061 60.58 188C60.58 186.939 60.1586 185.922 59.4084 185.172C58.6583 184.421 57.6409 184 56.58 184Z" fill="black"/>
                      <path d="M188 131.42C186.939 131.42 185.922 131.841 185.172 132.592C184.421 133.342 184 134.359 184 135.42V184H135.42C134.359 184 133.342 184.421 132.592 185.172C131.841 185.922 131.42 186.939 131.42 188C131.42 189.061 131.841 190.078 132.592 190.828C133.342 191.579 134.359 192 135.42 192H188C189.061 192 190.078 191.579 190.828 190.828C191.579 190.078 192 189.061 192 188V135.42C192 134.359 191.579 133.342 190.828 132.592C190.078 131.841 189.061 131.42 188 131.42Z" fill="black"/>
                      <path d="M188 0H135.42C134.359 0 133.342 0.421428 132.592 1.17157C131.841 1.92172 131.42 2.93913 131.42 4C131.42 5.06087 131.841 6.07828 132.592 6.82843C133.342 7.57857 134.359 8 135.42 8H184V56.58C184 57.6409 184.421 58.6583 185.172 59.4084C185.922 60.1586 186.939 60.58 188 60.58C189.061 60.58 190.078 60.1586 190.828 59.4084C191.579 58.6583 192 57.6409 192 56.58V4C192 2.93913 191.579 1.92172 190.828 1.17157C190.078 0.421428 189.061 0 188 0Z" fill="black"/>
                      </svg>
                      <div>
                        <svg width="192" height="192" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M149.24 149.74C153.12 151.74 159.24 155.9 159.24 155.94C159.896 156.381 160.669 156.618 161.46 156.62C162.322 156.624 163.162 156.35 163.855 155.838C164.549 155.325 165.058 154.603 165.308 153.778C165.557 152.953 165.534 152.069 165.24 151.259C164.947 150.448 164.4 149.754 163.68 149.28C163.42 149.1 157.12 144.92 152.9 142.66C147.06 139.58 127.08 134.24 120.64 132.66C119.24 129.94 116.64 125.08 115.6 122.94C116.975 121.394 118.225 119.742 119.34 118C124.4 110 125.6 105.18 127.46 96.78L127.86 95C128.26 93.2 128.62 91.62 128.92 90.14C133.32 82.46 134.92 71.76 134.92 64.94C134.9 46 124.68 26 96 26C69.18 26 57.1 48.72 57.1 64.84C56.8694 73.2559 58.6018 81.6098 62.16 89.24C63.6396 99.4481 67.2144 109.24 72.66 118C73.4643 119.292 74.3459 120.534 75.3 121.72C73.7 126 72 130.2 71.14 132.54C60.2664 134.907 49.6296 138.254 39.36 142.54C35.3563 144.454 31.5513 146.759 28 149.42C27.1539 150.062 26.5975 151.013 26.4531 152.066C26.3087 153.118 26.5881 154.184 27.23 155.03C27.8718 155.876 28.8234 156.432 29.8755 156.577C30.9276 156.721 31.9939 156.442 32.84 155.8C35.9198 153.556 39.2083 151.614 42.66 150C49.3727 147.103 56.2918 144.709 63.36 142.84C67.32 150.46 79.66 160 96 160C113.02 160 124.96 150.5 128.7 143.02C135.695 144.778 142.558 147.023 149.24 149.74ZM70 87.34C69.944 86.949 69.8223 86.5703 69.64 86.22C66.4373 79.5613 64.8999 72.2243 65.16 64.84C65.1 56.84 70.78 34 96 34C123.88 34 126.9 55.58 126.9 64.84C126.9 65.58 126.9 66.36 126.9 67.18C126.22 66.32 125.46 65.42 124.56 64.4L122.88 62.4C118.32 57.5359 113.326 53.0975 107.96 49.14C107.134 48.5254 106.102 48.2531 105.08 48.38C104.18 48.5 83.08 51.26 73.26 61.14C72.6047 61.9052 72.2622 62.8895 72.3011 63.8962C72.34 64.9029 72.7573 65.8579 73.4697 66.5703C74.1821 67.2826 75.1371 67.7 76.1438 67.7388C77.1505 67.7777 78.1348 67.4353 78.9 66.78C84.9 60.78 98.18 57.58 104.5 56.56C108.908 59.8667 113.017 63.5542 116.78 67.58C117.42 68.3 117.98 68.98 118.5 69.58C122.26 73.94 122.5 74.2 122.5 77.74C122.288 82.9617 121.449 88.1389 120 93.16L119.6 94.98C117.84 102.98 116.88 106.68 112.5 113.68C107.54 121.72 100.28 126 96 126C91.72 126 84.46 121.68 79.44 113.64C74.5024 105.623 71.2875 96.6667 70 87.34ZM96 152C91.3111 152.106 86.6596 151.143 82.3976 149.185C78.1356 147.228 74.3749 144.326 71.4 140.7C73.4 140.2 74.76 139.92 74.82 139.92C75.41 139.797 75.9647 139.543 76.4426 139.176C76.9205 138.809 77.3093 138.338 77.58 137.8C78.18 136.58 79.98 131.8 81.58 127.92C85.5887 131.475 90.6561 133.612 96 134C101.022 133.686 105.814 131.781 109.68 128.56C111.34 131.78 113.82 136.56 114.42 137.76C114.685 138.256 115.052 138.691 115.497 139.035C115.941 139.38 116.453 139.627 117 139.76L120.72 140.72C117.727 144.354 113.945 147.258 109.662 149.213C105.379 151.167 100.706 152.12 96 152Z" fill="#BB6BD9" stroke="#BB6BD9" strokeWidth="1.5"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <div className="promote__complex-row-plus"><img src="/img/promote/complex_plus.svg" /></div>
                </div>
                <div>
                  <div>Медийная реклама</div>
                  <div>
                    <div className="promote__complex-icon promote__complex-icon3">
                      <svg width="256" height="180" viewBox="0 0 256 180" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M252 0H4C2.93913 0 1.92172 0.421428 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4L0 176C0 177.061 0.421427 178.078 1.17157 178.828C1.92172 179.579 2.93913 180 4 180H252C253.061 180 254.078 179.579 254.828 178.828C255.579 178.078 256 177.061 256 176V4C256 2.93913 255.579 1.92172 254.828 1.17157C254.078 0.421428 253.061 0 252 0ZM32 74H8V58H32V74ZM32 82V98H8V82H32ZM32 106V122H8V106H32ZM32 50H8V34H32V50ZM8 130H32V146H8V130ZM40 8H216V172H40V8ZM224 106H248V122H224V106ZM224 98V82H248V98H224ZM224 74V58H248V74H224ZM224 50V34H248V50H224ZM224 130H248V146H224V130ZM248 26H224V8H248V26ZM32 8V26H8V8H32ZM8 154H32V172H8V154ZM224 172V154H248V172H224Z" fill="black"/>
                      </svg>
                      <div>
                        <svg width="256" height="180" viewBox="0 0 256 180" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M176 86.54L94 39.2C93.3922 38.8491 92.7028 38.6642 92.001 38.6641C91.2992 38.6639 90.6097 38.8483 90.0018 39.1989C89.3938 39.5495 88.8888 40.0539 88.5374 40.6614C88.1861 41.2689 88.0007 41.9582 88 42.66V137.34C88.0007 138.042 88.1861 138.731 88.5374 139.339C88.8888 139.946 89.3938 140.45 90.0018 140.801C90.6097 141.152 91.2992 141.336 92.001 141.336C92.7028 141.336 93.3922 141.151 94 140.8L176 93.46C176.606 93.1083 177.109 92.6037 177.459 91.9964C177.809 91.3892 177.993 90.7007 177.993 90C177.993 89.2992 177.809 88.6107 177.459 88.0035C177.109 87.3963 176.606 86.8916 176 86.54ZM96 130.42V49.58L166 90L96 130.42Z" fill="#219653" stroke="#219653"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className="marketing-complex">
              <div className="marketing-title2">
                Работаем
                <br />
                на результат
              </div>

              <div className="marketing-complex__list">
                <div className="marketing-complex__item marketing-complex__item1">
                  <img src="/sources/img/marketing/complex90.svg" />
                  клиентов ежегодно
                  <br />
                  продлевают
                  <br />
                  контракт
                </div>
                <div className="marketing-complex__item-sep" />
                <div className="marketing-complex__item marketing-complex__item2">
                  <img src="/sources/img/marketing/complex50000.svg" />
                  подтвержденных
                  <br />
                  целевых звонков
                  <br />
                  для наших клиентов
                </div>
                <div className="marketing-complex__item-sep" />
                <div className="marketing-complex__item marketing-complex__item3">
                  <img src="/sources/img/marketing/complex400.svg" />
                  кампаний создаем
                  <br />
                  ежегодно
                </div>
              </div>
            </section>

            <section className="marketing-hon">
              <div className="marketing-title2">
                Честность
                <br />
                и долгосрочные
                <br />
                отношения
              </div>

              <div className="marketing-hon__list">
                <div className="marketing-hon__item marketing-hon__item1">
                  <div>
                    <img src="/sources/img/marketing/h1_1.svg?1" />
                    <img src="/sources/img/marketing/h1_2.svg?1" />
                  </div>
                  Профессиональная настройка
                </div>
                <div className="marketing-hon__item marketing-hon__item2">
                  <div>
                    <img src="/sources/img/marketing/h2.svg?1" />
                    <img src="/sources/img/marketing/h2_2.svg?1" />
                  </div>
                  Доступ к&nbsp;кабинетам 24/7
                </div>
                <div className="marketing-hon__item marketing-hon__item3">
                  <div>
                    <svg
                      width="135"
                      height="134"
                      viewBox="0 0 135 134"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M67.6665 90.4375C63.031 90.4375 58.4996 89.0629 54.6453 86.4876C50.7911 83.9122 47.787 80.2518 46.0131 75.9692C44.2392 71.6865 43.775 66.974 44.6794 62.4276C45.5837 57.8812 47.8159 53.705 51.0937 50.4272C54.3715 47.1494 58.5477 44.9172 63.0941 44.0129C67.6405 43.1085 72.353 43.5727 76.6357 45.3466C80.9183 47.1205 84.5787 50.1246 87.1541 53.9788C89.7294 57.8331 91.104 62.3645 91.104 67C91.104 73.216 88.6347 79.1774 84.2393 83.5728C79.8439 87.9682 73.8825 90.4375 67.6665 90.4375ZM67.6665 48.25C63.9581 48.25 60.333 49.3497 57.2496 51.41C54.1662 53.4702 51.7629 56.3986 50.3438 59.8247C48.9246 63.2508 48.5533 67.0208 49.2768 70.658C50.0003 74.2951 51.786 77.636 54.4083 80.2583C57.0305 82.8805 60.3714 84.6663 64.0086 85.3897C67.6457 86.1132 71.4157 85.7419 74.8418 84.3228C78.2679 82.9036 81.1963 80.5004 83.2566 77.417C85.3168 74.3335 86.4165 70.7084 86.4165 67C86.4165 62.0272 84.4411 57.2581 80.9248 53.7418C77.4085 50.2255 72.6393 48.25 67.6665 48.25Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M52.0455 35.418L42.1783 11.5938C41.9405 11.0111 41.944 10.3577 42.1879 9.77754C42.4319 9.19735 42.8963 8.73783 43.4791 8.50007C44.0618 8.2623 44.7152 8.26578 45.2953 8.50972C45.8755 8.75366 46.3351 9.21809 46.5728 9.80085L56.44 33.6251C56.6778 34.2 56.6774 34.8459 56.4389 35.4206C56.2005 35.9953 55.7435 36.4517 55.1685 36.6895C54.5935 36.9273 53.9476 36.9269 53.373 36.6884C52.7983 36.45 52.3418 35.993 52.1041 35.418H52.0455Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M88.8193 124.199L78.9521 100.374C78.7822 99.813 78.8289 99.2083 79.083 98.6797C79.3372 98.1511 79.7803 97.737 80.3249 97.5192C80.8694 97.3014 81.4759 97.2956 82.0245 97.5031C82.5731 97.7106 83.0239 98.1163 83.288 98.64L93.1552 122.464C93.393 123.039 93.3926 123.685 93.1541 124.26C92.9157 124.834 92.4587 125.291 91.8837 125.529C91.3087 125.766 90.6629 125.766 90.0882 125.528C89.5135 125.289 89.057 124.832 88.8193 124.257V124.199Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M97.9829 54.4486C97.8654 54.1603 97.8066 53.8516 97.8097 53.5403C97.8128 53.2291 97.8779 52.9215 98.0012 52.6357C98.1245 52.3499 98.3034 52.0915 98.5277 51.8756C98.7519 51.6597 99.0169 51.4906 99.3071 51.3782L123.131 41.5111C123.706 41.2733 124.352 41.2737 124.927 41.5121C125.502 41.7506 125.958 42.2076 126.196 42.7825C126.434 43.3575 126.433 44.0034 126.195 44.5781C125.956 45.1528 125.499 45.6092 124.924 45.847L101.042 55.7142C100.468 55.9511 99.824 55.9509 99.2506 55.7136C98.6772 55.4764 98.2214 55.0214 97.9829 54.4486Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M9.2017 91.222C9.08259 90.9373 9.02085 90.632 9.02003 90.3235C9.0192 90.0149 9.07931 89.7093 9.1969 89.424C9.31449 89.1387 9.48724 88.8795 9.70525 88.6612C9.92326 88.4428 10.1822 88.2697 10.4673 88.1517L34.2915 78.2845C34.8665 78.0467 35.5124 78.0471 36.0871 78.2856C36.6618 78.524 37.1182 78.981 37.356 79.556C37.5938 80.131 37.5934 80.7768 37.3549 81.3515C37.1165 81.9262 36.6595 82.3827 36.0845 82.6204L12.2603 92.4876C11.6868 92.7245 11.0427 92.7243 10.4694 92.487C9.89601 92.2498 9.44013 91.7948 9.2017 91.222Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M80.2286 36.6829C79.9439 36.566 79.685 36.3941 79.4667 36.1771C79.2484 35.9601 79.075 35.7022 78.9564 35.4182C78.8378 35.1342 78.7763 34.8296 78.7754 34.5218C78.7745 34.214 78.8342 33.909 78.9512 33.6243L91.959 2.2298C92.0768 1.9451 92.2494 1.68637 92.4671 1.4684C92.6848 1.25042 92.9434 1.07746 93.2279 0.95939C93.5125 0.841321 93.8175 0.780458 94.1256 0.780274C94.4337 0.78009 94.7388 0.840589 95.0235 0.958317C95.3082 1.07604 95.5669 1.2487 95.7849 1.46641C96.0029 1.68413 96.1758 1.94265 96.2939 2.22721C96.412 2.51177 96.4728 2.8168 96.473 3.12488C96.4732 3.43297 96.4127 3.73807 96.295 4.02277L83.2872 35.4173C83.0487 35.9902 82.5928 36.4451 82.0195 36.6824C81.4461 36.9196 80.8021 36.9198 80.2286 36.6829Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M40.3152 133.046C40.0291 132.929 39.7689 132.757 39.5497 132.539C39.3304 132.321 39.1564 132.062 39.0377 131.777C38.919 131.491 38.8579 131.185 38.8579 130.876C38.8579 130.567 38.9191 130.261 39.0379 129.976L52.0457 98.64C52.2834 98.065 52.7399 97.608 53.3146 97.3695C53.8893 97.1311 54.5352 97.1307 55.1101 97.3685C55.6851 97.6062 56.1421 98.0627 56.3805 98.6374C56.619 99.2121 56.6194 99.8579 56.3816 100.433L43.3738 131.827C43.1266 132.392 42.667 132.836 42.0946 133.064C41.5221 133.292 40.8829 133.286 40.3152 133.046Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M130.643 95.6282L99.3069 82.6204C98.732 82.3827 98.275 81.9262 98.0365 81.3515C97.7981 80.7768 97.7977 80.131 98.0355 79.556C98.2732 78.981 98.7297 78.524 99.3044 78.2856C99.8791 78.0471 100.525 78.0467 101.1 78.2845L132.494 91.2923C132.779 91.41 133.038 91.5827 133.256 91.8004C133.474 92.0181 133.647 92.2766 133.765 92.5612C133.883 92.8458 133.944 93.1508 133.944 93.4589C133.944 93.767 133.884 94.0721 133.766 94.3568C133.648 94.6415 133.476 94.9002 133.258 95.1182C133.04 95.3361 132.782 95.5091 132.497 95.6272C132.212 95.7452 131.907 95.8061 131.599 95.8063C131.291 95.8065 130.986 95.746 130.701 95.6282H130.643Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M34.2913 55.7142L2.89679 42.7064C2.61209 42.5886 2.35337 42.416 2.13539 42.1983C1.91741 41.9806 1.74445 41.722 1.62638 41.4375C1.50831 41.1529 1.44745 40.8479 1.44727 40.5398C1.44708 40.2317 1.50758 39.9266 1.62531 39.6419C1.74304 39.3572 1.91569 39.0985 2.1334 38.8805C2.35112 38.6625 2.60964 38.4896 2.8942 38.3715C3.17876 38.2534 3.48379 38.1926 3.79188 38.1924C4.09996 38.1922 4.40506 38.2527 4.68976 38.3704L36.0843 51.3782C36.369 51.496 36.6277 51.6686 36.8457 51.8863C37.0637 52.1041 37.2366 52.3626 37.3547 52.6471C37.4728 52.9317 37.5336 53.2367 37.5338 53.5448C37.534 53.8529 37.4735 54.158 37.3558 54.4427C37.2381 54.7274 37.0654 54.9861 36.8477 55.2041C36.63 55.4221 36.3715 55.595 36.0869 55.7131C35.8023 55.8312 35.4973 55.892 35.1892 55.8922C34.8811 55.8924 34.576 55.8319 34.2913 55.7142Z"
                        fill="#F2994A"
                        stroke="#F2994A"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </div>
                  Прозрачная, информативная отчетность
                </div>
                <div className="marketing-hon__item marketing-hon__item4">
                  <div>
                    <img src="/sources/img/marketing/h4_1.svg?1" />
                    <img src="/sources/img/marketing/h4_2.svg?1" />
                  </div>
                  Отвечаем за результат&nbsp;– работаем по&nbsp;KPI
                </div>
              </div>
            </section>

            <section className="marketing-work" data-type="6">
              <div className="marketing-title2">
                Этапы работы
              </div>

              <div className="marketing-work__in">
                <div className="marketing-work__img">
                  <div className="marketing-work__img-bg" />
                  <img src="/sources/img/marketing/work_p1.svg" />
                  <img src="/sources/img/marketing/work_p2.svg?1" />
                </div>
                <div>
                  <div className="marketing-work__item marketing-work__item1">
                    <span>01</span>
                    <p>
                      разрабатываем <br />
                      индивидуальную <br />
                      стратегию <br />
                      продвижения
                    </p>
                  </div>
                  <div className="marketing-work__item marketing-work__item2">
                    <span>02</span>
                    <p>
                      создаем качественные <br />
                      рекламные кампании
                    </p>
                  </div>
                  <div className="marketing-work__item marketing-work__item3">
                    <span>03</span>
                    <p>
                      внедряем сквозную <br />
                      аналитику
                    </p>
                  </div>
                  <div className="marketing-work__item marketing-work__item4">
                    <span>04</span>
                    <p>
                      автоматизируем <br />
                      процессы
                    </p>
                  </div>

                  <div className="marketing-work__item marketing-work__item5">
                    <span>05</span>
                    <p>
                      Вы получаете
                      <br />
                      звонки и заявки
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="marketing-prof">
              <div className="marketing-prof__in">
                <div className="marketing-title2">
                  Доказанный
                  <br />
                  профессионализм
                </div>

                <div className="marketing-prof__row">
                  <img src="/sources/img/marketing/logos/p1.png" />
                  <img src="/sources/img/marketing/logos/p2.png" />
                  <img src="/sources/img/marketing/logos/p3.png" />
                </div>

                <div className="marketing-prof__row">
                  <img src="/sources/img/marketing/logos/p4.png" />
                  <img src="/sources/img/marketing/logos/p5.png" />
                  <img src="/sources/img/marketing/logos/p6.png" />
                  <img src="/sources/img/marketing/logos/p7.png" />
                </div>
              </div>
            </section>

            <section className="marketing-technology">
              <div className="marketing-title2">
                Лучшие технологии
                <br />
                digital–рынка
                <br />
                для увеличения
                <br />
                ваших продаж
              </div>

              <div className="marketing-technology__row">
                <div>
                  Собственная разработка для управления контекстной рекламой
                </div>
                <div>
                  <img src="/sources/img/marketing/logos/t1.png" />
                </div>
              </div>
              <div className="marketing-technology__row">
                <div>Подсчет и аналитика звонков</div>
                <div>
                  <img src="/sources/img/marketing/logos/t2.png" />
                  <img src="/sources/img/marketing/logos/t3.png" />
                  <img src="/sources/img/marketing/logos/t4.png" />
                </div>
              </div>
              <div className="marketing-technology__row">
                <div>CRM</div>
                <div>
                  <img src="/sources/img/marketing/logos/t5.png" />
                </div>
              </div>
              <div className="marketing-technology__row">
                <div>Инструменты веб-аналитики</div>
                <div>
                  <img src="/sources/img/marketing/logos/t6.png" />
                  <img src="/sources/img/marketing/logos/t7.png" />
                </div>
              </div>
              <div className="marketing-technology__row">
                <div>Визуализация данных</div>
                <div>
                  <img src="/sources/img/marketing/logos/t8.png" />
                  <img src="/sources/img/marketing/logos/t9.png" />
                  <img src="/sources/img/marketing/logos/t10.png" />
                </div>
              </div>
            </section>

            <div className="promote__bottom-wrap">
              <div className="promote__bottom">
                <div className="marketing-title2">
                  У нас всё готово <br />
                  к запуску!
                </div>
                <span onClick={() => props.openPopup(true)} className="promote__bottom-button">
                  <span>Ключ на старт!</span>
                  <img src="/img/promote/arrow.svg" />
                </span>

                <video playsInline loop muted autoPlay>
                  <source src="/video/promote/bottom_n.mp4" type="video/mp4" />
                </video>
              </div>

              <div className="promote__bottom-el1" />
              <div className="promote__bottom-el2" />
              <div className="promote__bottom-el3" />
            </div>

            {isReferrer() && (
              <div className="promote__referrer">
                <a target="_blank" href="/digital">
                  <div className="digital_link-wrap">
                    <div className="digital_link-img-wrap">
                      <div className="digital_link-dots dots-1"></div>
                      <div className="digital_link-dots dots-2"></div>
                      <div className="digital_link-dots dots-3"></div>
                      <div className="digital_link-dots dots-4"></div>
                      <div className="digital_link-dots dots-5"></div>
                      <img src="/sources/img/rocket.svg" />
                    </div>
                    <div className="digital_link-link">Получите презентацию</div>
                  </div>
                </a>

                <SourcesMarketingFormReferrer />
              </div>
            )}

            {/*<div className="marketing-footer-wrap">
              <section className="marketing-footer-new">
                <div className="marketing-footer-new__in">
                  <div>
                    <div>
                      Приглашаем <br />в гости
                    </div>
                    <Link
                      to="/contacts"
                      onClick={() => {
                        ym("reachGoal", "click_on_guests");
                        return true;
                      }}
                    >
                      Мы рядом
                    </Link>
                  </div>
                  <div>
                    <div>
                      Ждём <br />
                      звонка
                    </div>
                    <a
                      href="tel: +7 (495) 921-41-70"
                      onClick={() => {
                        ym("reachGoal", "click_on_call_me");
                        return true;
                      }}
                    >
                      +7 (495) 921-41-70
                    </a>
                  </div>
                  <div>
                    <div>
                      Перезвоним <br />
                      сами
                    </div>
                    <span
                      onClick={() => {
                        setPopup(true)
                        ym("reachGoal", "click_on_callback");
                        return true;
                      }}
                    >
                      Быстро
                    </span>
                  </div>
                </div>
              </section>
            </div>*/}

            <a className="footer-lnk white" href="/docs/politika_konfidencialnosti_i_obrabotki_personalnyh_dannyh.pdf" target="_blank">Политика конфиденциальности</a>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PromoteDesctope)